
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConverterAcdc as ObiConverterAcdcElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-converter-acdc.js';
 
 
 

 
 export const ObiConverterAcdc = createComponent({
   react: React,
   tagName: 'obi-converter-acdc',
   elementClass: ObiConverterAcdcElement,
   events: {
     
   }
  });
 
 